import React from "react";
import JointShareholderTable from "./JointShareholderTable";
import Button from "components/lib/Shared/Button";

const JointShareholderTableSubrow = ({ visibleColumns, jointShareholders }) => {
  return (
    <tr className="bg-[#EDF0F5]">
      <td colSpan={visibleColumns.length} className="px-3">
        <div className="mt-5 mb-4">
          <div>
            <JointShareholderTable jointShareholders={jointShareholders} />
          </div>
          {/* <div className="flex justify-end mt-3">
            <Button>Submit List</Button>
          </div> */}
        </div>
      </td>
    </tr>
  );
};

export default JointShareholderTableSubrow;
